import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Paper } from 'material-ui';
import ReportList from './reportList';
import RightSide from './rightSide';

class ContractingReports extends Component {

  render() {
    return (
      <div className="Grid">
        <Paper className="Grid-cell Grid--full">
          <div className="flex-tc-sb">
            <div style={{
              width: '20%',
              fontSize: '16px',
              backgroundColor: '#383E4B',
              color: 'white',
              paddingBottom: '24px',
            }}
            >
              <ReportList />
            </div>
            <div
              style={{
                width: '80%',
                textAlign: 'center',
              }}
            >
              <RightSide />
            </div>
          </div>
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = ({ contracting: { currentYear } }) => ({
  startDate: currentYear.startDate,
  endDate: currentYear.endDate,
});

export default connect(mapStateToProps)(ContractingReports);



// WEBPACK FOOTER //
// ./src/app/components/contracting-reports/container.jsx